import Isotope from "isotope-layout";
import Swiper from "swiper";
import { getPostTypeRoute } from './imigoWebConfig';

export const getCookie = (name) => {
  var cookieArr = document.cookie.split(";");
  for (var i = 0; i < cookieArr.length; i++) {
    var cookiePair = cookieArr[i].split("=");

    /* Removing whitespace at the beginning of the cookie name
        and compare it with the given string */
    if (name === cookiePair[0].trim()) {
      return decodeURIComponent(cookiePair[1]);
    }
  }

  return null;
};

export const getParents = (elem) => {
  var parents = [];
  while (elem.parentNode && elem.parentNode.nodeName.toLowerCase() !== "body") {
    elem = elem.parentNode;
    parents.push(elem);
  }
  return parents;
};

export const addZeroBeforeNumber = (number) => {
  return number > 9 ? number : `0${number}`;
};

export const initializeSwiper = (item, params) => {
  const swiper_el = new Swiper(item, params);
  swiper_el.init();
  return swiper_el;
};

export const initializeIsotop = (item) => {
  let filter_menu = item.closest(".grid-wrapper").querySelector(".filter-menu");

  const grid = new Isotope(item, {
    itemSelector: ".grid-item",
    layoutMode: "masonry",
    percentPosition: true,
    stagger: 0,
    masonry: {
      columnWidth: ".grid-sizer",
    },
  });

  setTimeout(() => {
    grid.arrange({ filter: `*` });
  }, 1000);

  filter_menu &&
    filter_menu.querySelectorAll("li").forEach((el) => {
      el.querySelector("span").addEventListener("click", function (e) {
        let element = e.target,
          filtered_text = element.getAttribute("data-filter");

        filter_menu
          .querySelectorAll("li")
          .forEach((elm) => elm.classList.remove("active"));
        element.closest("li").classList.add("active");
        grid.arrange({
          filter: filtered_text === "*" ? "*" : `.${filtered_text}`,
        });
      });
    });

  return grid;
};

export const InputField = (value) => {
  document.querySelectorAll(".quantity").forEach((item) => {
    let num = value ? value : 0,
      el = item.querySelector(".qty-text"),
      plusBtn = item.querySelector(".qty-plus"),
      minusBtn = item.querySelector(".qty-minus");

    plusBtn.addEventListener("click", () => {
      num = num + 1;
      el.setAttribute("value", num);
    });

    minusBtn.addEventListener("click", () => {
      num = num > 0 ? num - 1 : 0;
      el.setAttribute("value", num);
    });

    el.setAttribute("value", num);
  });
};

export const sendEmail = async (data) => {
  const req = await fetch(`${process.env.REACT_APP_API_URL}/send`, {
    method: "post",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  })
    .then((res) => res.json())
    .then((data) => data);
  return await req;
};

export const resetForm = (actions, recaptcha) => {
  if (actions) {
    actions.resetForm();
    actions.setStatus(true);
    actions.setSubmitting(false);
    setTimeout(() => actions.setStatus(false), 5000);
  }

  if (recaptcha) {
    recaptcha.current.reset();
    recaptcha.current.captcha.classList.remove("error");
  }
};

// Format date to a readable format
export const formatDate = (dateString) => {
  const options = { year: 'numeric', month: 'short', day: 'numeric' };
  return new Date(dateString).toLocaleDateString(undefined, options);
};

// Set header menu position
export const SetHeaderMenuPos = () => {
  const header = document.querySelector("header");
  const stickyHeaders = document.querySelectorAll(".sticky-header");
  const headerHeight = header?.offsetHeight;

  stickyHeaders.forEach(function (stickyHeader) {
    stickyHeader.style.top = headerHeight + "px";
  });
};

// Set document full height
export const setDocumentFullHeight = () => {
  const documentHeight = Math.max(
    document.body.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.clientHeight,
    document.documentElement.scrollHeight,
    document.documentElement.offsetHeight
  );
  document.documentElement.style.setProperty(
    "--viewport-height",
    `${window.innerHeight}px`
  );
  document.documentElement.style.setProperty(
    "--document-height",
    `${documentHeight}px`
  );
};

// Strip HTML tags from string
export const stripHtml = (html) => {
  const doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.body.textContent || '';
};

// Get excerpt from text
export const getExcerpt = (text, maxLength = 150) => {
  const strippedText = typeof text === 'string' ? stripHtml(text) : '';
  return strippedText.length > maxLength 
    ? `${strippedText.substring(0, maxLength)}...` 
    : strippedText;
};

// Generate SEO-friendly slug
export const generateSlug = (text) => {
  return text
    .toString()
    .toLowerCase()
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
};

// Get image URL from Strapi format (supports nested + flat API shapes)
export const getImageUrl = (picture, format = 'medium') => {
  const MEDIA = 'https://panel.imigo.app'
  const fallback = `${MEDIA}/uploads/medium_logo_baf7005f31.jpg`

  if (!picture) return fallback

  if (typeof picture === 'string') {
    return picture.startsWith('http') ? picture : `${MEDIA}${picture}`
  }

  const attrs = picture?.data?.attributes || picture?.attributes || picture
  if (!attrs) return fallback

  const formats = attrs.formats || {}
  const preferred =
    format === 'large'
      ? ['large', 'medium', 'small', 'thumbnail']
      : format === 'thumbnail'
        ? ['thumbnail', 'small', 'medium', 'large']
        : ['medium', 'small', 'thumbnail', 'large']

  for (const key of preferred) {
    const url = formats[key]?.url
    if (url) return `${MEDIA}${url}`
  }

  if (attrs.url) return `${MEDIA}${attrs.url}`
  return fallback
}

// Get post type URL segment (plural, lowercase)
export const getPostTypeUrl = (postType) => {
  return getPostTypeRoute(postType);
};

// Get post URL with optional language prefix
export const getPostUrl = (post, language = 'en') => {
  if (!post) return `/${language}/`;

  const slug = post.attributes?.slug;
  const id = post.id;
  const urlIdentifier = slug || id;
  const postTypeRoute = getPostTypeUrl(post.attributes?.post_type);

  return `/${language}/${postTypeRoute}/${urlIdentifier}`;
};

// Handle API errors
export const handleApiError = (error) => {
  console.error('API Error:', error);
  return {
    message: error.response?.data?.error?.message || 'An error occurred',
    status: error.response?.status || 500
  };
};

// Get flag path from nationality data
export const getFlagPath = (nationality) => {
  if (!nationality || !nationality.data || !nationality.data.attributes) {
    return null;
  }
  
  const attributes = nationality.data.attributes;
  
  // Try to get country code from various possible fields
  let countryCode = attributes.country_code || attributes.language_query;
  
  // If country code is not available, try to extract from flag URL
  if (!countryCode && attributes.flag?.data?.attributes?.url) {
    const flagUrl = attributes.flag.data.attributes.url;
    // Extract country code from URL if it follows a pattern like /flags/us.svg or /uploads/flags/us.svg
    const match = flagUrl.match(/\/([a-z]{2})\.(svg|png|jpg)/i);
    if (match) {
      countryCode = match[1].toLowerCase();
    }
  }
  
  // If still no country code, return null
  if (!countryCode) {
    return null;
  }
  
  // Normalize country code to lowercase and ensure it's 2 characters
  countryCode = countryCode.toLowerCase().trim();
  
  // Validate that it's a 2-letter country code
  if (countryCode.length !== 2 || !/^[a-z]{2}$/.test(countryCode)) {
    return null;
  }
  
  // Return the flag path
  return `/assets/flags/${countryCode}.svg`;
};
